import React from 'react'
import PackingItemPage from './PackingItemPage'
import '../styles/index.scss'

function PackingItemPageContainer() {
    return (
        <div className='PackingItemPageContainer'>
            <PackingItemPage/>
        </div>
    )
}

export default PackingItemPageContainer